import DataExchange from './DataExchange'

import QueryString from '@/utils/QueryString'

export const MAX_PRICE = 50000

export default class PricePerPersonWFFMDataExchange extends DataExchange {
  /**
   * @param {HTMLFormElement} form
   */
  constructor (form) {
    super(form)

    /** @type HTMLElement */
    this.pricePerPersonSelector = form.querySelector('.custom-select-price-person')
    /** @type Array<HTMLElement> */
    this.inputs = this.pricePerPersonSelector.querySelectorAll('div.radio').toArray()
    /** @type HTMLInputElement */
    this.input = form.querySelector('.custom-select-price-range .form-control')
  }

  get data () {
    const result = {
      type: 'man',
      selected: this.getSelected(),
      options: this.getOptions(),
    }

    return result
  }

  set data (value) {
    this.setSelected(value.selected, value.type)
  }

  get queryComponent () {
    const selected = this.input.value.replace(/;.*$/, '').split(':')

    return `PriceFrom=${selected[0]}&PriceTo=${selected[1]}`
  }

  getSelected () {
    const qs = new QueryString()
    if (qs.exists('PriceFrom') && qs.exists('PriceTo')) {
      const selected = `${qs.get('PriceFrom')}:${qs.get('PriceTo')}`
      if (selected == `4000:${MAX_PRICE}`) return '4000:0'
      else return selected
    } else {
      return '0:0'
    }
  }

  setSelected (selected, type) {
    this.inputs.forEach(input => {
      const radio = input.querySelector('input[type="radio"]')
      radio.checked = selected == radio.value
    })
    if (selected === '0:0') {
      this.input.value = `0:${MAX_PRICE};${type}`
    } else if (selected === '4000:0') {
      this.input.value = `4000:${MAX_PRICE};${type}`
    } else {
      this.input.value = `${selected};${type}`
    }
  }

  getOptions () {
    return this.inputs.map(input => ({
      value: input.querySelector('input[type="radio"]').value,
      name: input.querySelector('label').innerText,
      enabled: true,
    }))
  }
}



// WEBPACK FOOTER //
// ./src/services/PricePerPersonWFFMDataExchange.js